import React, { useEffect, useRef, useState } from 'react';
import logger from '../../../utils/logger';
import '../styles/MedicosAldia.css';
import { congresosData } from '../../../utils/congresosData';
import cicleto from '../../../assets/Ciclesona-T.png';
import InvestigacionModal from '../../../shared/modals/InvestigacionModal';

const MedicosAldia = ({ activeSection }) => {
  const [congresoActivo, setCongresoActivo] = useState('otorrinolaringologia');
  const [modalInvestigacionVisible, setModalInvestigacionVisible] =
    useState(false);

  // References for scrolling to sections
  const congresosRef = useRef(null);
  const noticiasRef = useRef(null);

  // Obtener datos del congreso actual
  const datosActuales = congresosData[congresoActivo];

  // Lista de congresos disponibles
  const congresosDisponibles = [
    { id: 'otorrinolaringologia', nombre: 'Otorrinolaringología' },
    { id: 'asma', nombre: 'Asma Alergia e Inmunología' },
    { id: 'medicina', nombre: 'Medicina Interna' },
    { id: 'neumonologia', nombre: 'Neumonología y Cirugía de Tórax' },
    { id: 'puericultura', nombre: 'Puericultura y Pediatría' },
  ];

  // Función para abrir el modal de investigación
  const abrirModalInvestigacion = () => {
    setModalInvestigacionVisible(true);
  };

  // Función para cerrar el modal de investigación
  const cerrarModalInvestigacion = () => {
    setModalInvestigacionVisible(false);
  };

  // Scroll to the appropriate section based on activeSection prop
  useEffect(() => {
    // console.log('MedicosAldia: activeSection received:', activeSection);
    // console.log('MedicosAldia: noticiasRef.current:', noticiasRef.current);
    // console.log('MedicosAldia: congresosRef.current:', congresosRef.current);

    const timer = setTimeout(() => {
      if (activeSection === 'congresos' && congresosRef.current) {
        // console.log('MedicosAldia: Scrolling to congresos section');
        congresosRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (activeSection === 'noticias' && noticiasRef.current) {
        // console.log('MedicosAldia: Scrolling to noticias section');
        noticiasRef.current.scrollIntoView({ behavior: 'smooth' });
      } else {
        logger.debug(
          'MedicosAldia: No valid section or ref found for scrolling',
          {
            activeSection,
            hasCongresosRef: !!congresosRef.current,
            hasNoticiasRef: !!noticiasRef.current,
          }
        );
      }
    }, 100); // 100ms delay to ensure DOM is rendered

    return () => clearTimeout(timer); // Cleanup timer
  }, [activeSection]);

  return (
    <div className="doctores-container">
      {/* Título principal */}
      <h2 className="titulo">
        Médicos <span className="rosa">al día</span>
      </h2>

      {/* Sección de Congreso */}
      <div className="congreso-section" ref={congresosRef}>
        {/* Botones superiores dinámicos */}
        <div className="botones-superiores">
          {congresosDisponibles.map(congreso => (
            <button
              key={congreso.id}
              className={`btn-congreso ${congresoActivo === congreso.id ? 'activo' : ''}`}
              onClick={() => setCongresoActivo(congreso.id)}
            >
              Congreso {congreso.nombre}
            </button>
          ))}
        </div>

        <div className="congreso-collage">
          {/* Caja gris oscura para imagen 1 */}
          <div className="caja-gris-img1"></div>

          {/* Imagen 1 - Izquierda */}
          <div className="congreso-img congreso-img1">
            {datosActuales && datosActuales.imagenes[0] ? (
              <img
                src={datosActuales.imagenes[0].src}
                alt={datosActuales.imagenes[0].alt}
                className="imagen-congreso"
              />
            ) : (
              <div className="img-placeholder">Imagen Congreso 1</div>
            )}
          </div>

          {/* Caja rosa en el medio */}
          <div className="caja-rosa-medio">
            <div className="contenido-caja-rosa"></div>
          </div>

          {/* Imagen 2 - Arriba de la caja rosa */}
          <div className="congreso-img congreso-img2">
            {datosActuales && datosActuales.imagenes[1] ? (
              <img
                src={datosActuales.imagenes[1].src}
                alt={datosActuales.imagenes[1].alt}
                className="imagen-congreso"
              />
            ) : (
              <div className="img-placeholder">Imagen Congreso 2</div>
            )}
          </div>

          {/* Imagen 3 - Abajo de la caja rosa */}
          <div className="congreso-img congreso-img3">
            {datosActuales && datosActuales.imagenes[2] ? (
              <img
                src={datosActuales.imagenes[2].src}
                alt={datosActuales.imagenes[2].alt}
                className="imagen-congreso"
              />
            ) : (
              <div className="img-placeholder">Imagen Congreso 3</div>
            )}
          </div>

          {/* Caja gris oscura para imagen 4 */}
          <div className="caja-gris-img4"></div>

          {/* Imagen 4 - Derecha */}
          <div className="congreso-img congreso-img4">
            {datosActuales && datosActuales.imagenes[3] ? (
              <img
                src={datosActuales.imagenes[3].src}
                alt={datosActuales.imagenes[3].alt}
                className="imagen-congreso"
              />
            ) : (
              <div className="img-placeholder">Imagen Congreso 4</div>
            )}
          </div>
        </div>

        {/* Título del congreso dinámico */}
        <h3 className="congreso-titulo">
          <span className="congreso-numero">
            {datosActuales?.titulo.split(' ')[0] || 'XXXIII'}
          </span>{' '}
          {datosActuales?.titulo
            .substring(datosActuales.titulo.indexOf(' ') + 1)
            .split(' ')
            .map((word, index, array) =>
              word.toLowerCase() === 'de' && index < array.length - 1 ? (
                <span key={index} className="congreso-titulo-rosa sin-negrita">
                  {word}{' '}
                </span>
              ) : (
                <span key={index} className="congreso-titulo-rosa">
                  {word}{' '}
                </span>
              )
            )}
          <br />
          <span className="congreso-subtitulo">
            {datosActuales?.subtitulo || 'de Otorrinolaringología'}
          </span>
        </h3>

        {/* Descripción del congreso dinámico */}
        <div className="congreso-descripcion">
          <p>
            {datosActuales?.descripcion ||
              'Descripción del congreso no disponible.'}
          </p>
          {datosActuales?.descripcion2 && <p>{datosActuales.descripcion2}</p>}
        </div>
      </div>

      {/* Mensaje destacado original */}
      <p className="siempre-presentes">
        <span className="resaltar">
          <b>
            <span className="negro">Siempre</span>{' '}
            <span className="rosa">Presentes</span>
          </b>
          <br />
        </span>
        Ofrecemos medicamentos que cumplen con los más altos estándares de{' '}
        <br />
        <b>calidad, seguridad y eficacia.</b>
      </p>

      {/* Sección de últimas noticias */}
      <div className="ultimas-noticias" ref={noticiasRef} id="noticias">
        <h3>
          <span className="noticias-activa">Últimas</span>{' '}
          <span className="noticias-inactiva">noticias</span>
        </h3>

        <div className="noticias-grid">
          {/* Noticia 1 */}
          <div className="noticia-bloque">
            <div className="noticia-card1"></div>
          </div>

          {/* Noticia 2 - CON BOTÓN VER MÁS FUNCIONAL */}
          <div className="noticia-bloque">
            <div className="noticia-card2">
              <div className="noticia-card-morado" />
              <img
                src={cicleto}
                alt="Productos BIOMERCY"
                className="product-background-img-cicle"
              />
            </div>
            <div className="info-noticia-card2">
              <b>
                <span className="alianzaN">Investigación</span>
                <br />
                <span className="alianza">Ciclesona-T</span>
              </b>
              <p>
                Objetivo: Evaluar la eficacia clínica y seguridad a mediano
                plazo de <b>Ciclesona-T</b> en pacientes con
                <div className="centrado">
                  <b>EPOC GOLD-E</b>
                  <br />
                  {/* BOTÓN VER MÁS CON FUNCIONALIDAD */}
                  <button
                    className="ver-mas-btn"
                    onClick={abrirModalInvestigacion}
                  >
                    <b>Ver Más</b>
                  </button>
                </div>
              </p>
            </div>
          </div>

          {/* Noticia 3 */}
          <div className="noticia-bloque">
            <div className="noticia-card3"></div>
          </div>
        </div>
      </div>

      {/* MODAL DE INVESTIGACIÓN */}
      {modalInvestigacionVisible && (
        <InvestigacionModal
          isOpen={modalInvestigacionVisible}
          onClose={cerrarModalInvestigacion}
        />
      )}
    </div>
  );
};

export default MedicosAldia;
